module.exports = __webpack_public_path__ + "static/media/offline.cf7962e0.png";